import { Button, Card, Input, Col, Typography } from "antd";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import {
  editCompanyGroup,
  saveCompanyGroup,
  deleteCompanyGroup,
  getCompanyGroupById,
} from "api/companyGroup.api";
import IndustryLeaderDropdown from "components/common/industryLeaderDropdown/IndustryLeaderDropdown";
import { notificationController } from "controllers/notificationController";
interface Props {
  onCompanyAdded: any;
  groupId: any;
}

export const CompanyGroupForm: React.FC<Props> = ({
  onCompanyAdded,
  groupId,
}) => {
  const [selectedCompaniesList, setSelectedCompaniesList] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [grpLoading, setGrpLoading] = useState(false);
  const [groupName, setGroupName] = useState("");

  useEffect(() => {
    if (groupId && parseInt(groupId) > 0) {
      setGrpLoading(true);
      getCompanyGroup(parseInt(groupId));
    } else {
      resetForm();
    }
  }, [groupId]);

  const getCompanyGroup = (id: number) => {
    setGrpLoading(true);
    getCompanyGroupById(id).then(({ title, companies }) => {
      setGrpLoading(false);
      setGroupName(title);
      setSelectedCompaniesList(companies);
    });
  };
  const onSaveCompanyGroup = async () => {
    try {
      setLoading(true);
      if (groupId) {
        await editCompanyGroup(groupId, groupName, selectedCompaniesList);
        notificationController.success({
          message: "Company group updated successfully!",
        });
      } else {
        await saveCompanyGroup(groupName, selectedCompaniesList);
        notificationController.success({
          message: "Company group added successfully!",
        });
      }

      resetForm();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notificationController.error({
        message: "Something went wrong while adding company group",
      });
    }
  };
  const resetForm = () => {
    setGroupName("");
    setSelectedCompaniesList([]);
    onCompanyAdded();
  };

  const onDeleteCompanyGroup = () => {
    setLoading(true);
    deleteCompanyGroup(groupId).then(
      () => {
        setLoading(false);
        notificationController.success({
          message: "Company group deleted successfully!",
        });
        resetForm();
      },
      () => {
        notificationController.error({
          message: "Something went wrong while deleting the company group!",
        });
      }
    );
  };

  const updateGroupName = (value: string) => {
    setGroupName(value);
    console.log(groupId);
  };
  const addCompany = (value: string) => {
    let existingCompanies = selectedCompaniesList;
    if (selectedCompaniesList.indexOf(value) === -1) {
      existingCompanies.push(value);
      setSelectedCompaniesList(JSON.parse(JSON.stringify(existingCompanies)));
    }
  };

  const removeCompany = (value: string) => {
    let existingCompanies = selectedCompaniesList;
    existingCompanies.splice(existingCompanies.indexOf(value), 1);
    setSelectedCompaniesList(JSON.parse(JSON.stringify(existingCompanies)));
  };

  const styleFormLabel = {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#003a8c",
    marginBottom: "10px",
  };

  const { Title } = Typography;

  return (
    <>
      <Card className="mb-10" loading={grpLoading}>
        <Title level={5}>Create New Group</Title>
        <Card
          id="searchName"
          className="no-border-card input-searchname"
          bordered={false}
        >
          {/* <div className="field-title">Give a name to your search</div> */}
          <Col style={styleFormLabel}>
            <span className="required">*</span> Give a name to your list
          </Col>
          <Input
            size="large"
            placeholder="Name Your Group"
            value={groupName}
            onChange={(e) => {
              updateGroupName(e.target.value);
            }}
          ></Input>
        </Card>
        <Card
          id="company-group-search"
          className="no-border-card"
          bordered={false}
        >
          {/* <div className="field-title">Give a name to your search</div> */}
          <Col style={styleFormLabel}>
            <span className="required">*</span> Search by Company Name
          </Col>
          <IndustryLeaderDropdown
            size={"large"}
            styles={{ width: "75%" }}
            valueSetterRequired={false}
            defaultValue={[]}
            onChange={(selectedValue: any) => {
              addCompany(selectedValue[0].label);
            }}
            placeholder="ex. Apple Inc"
          ></IndustryLeaderDropdown>
        </Card>
        <Card className="no-border-card mt-20" bordered={false}>
          <Col style={styleFormLabel}>Your Selection</Col>
          <div className="your-selection-names">
            {selectedCompaniesList.length > 0 &&
              selectedCompaniesList.map((title: any) => {
                return (
                  <Button
                    type="primary"
                    size="small"
                    shape="round"
                    className="m-5 selected-tag company-group-tag"
                  >
                    {title}
                    <span
                      className="ms-5"
                      onClick={() => {
                        removeCompany(title);
                      }}
                    >
                      <CloseOutlined />
                    </span>
                  </Button>
                );
              })}
          </div>
        </Card>
        <div
          className="d-flex justify-content-end"
          style={{ justifyContent: "center" }}
        >
          <Button
            loading={loading}
            style={{ borderRadius: "4px" }}
            disabled={!groupId}
            size="middle"
            className="mt-20 mr-10"
            icon={<DeleteOutlined />}
            onClick={onDeleteCompanyGroup}
          >
            Delete Group
          </Button>

          <Button
            loading={loading}
            disabled={
              groupName.length === 0 || selectedCompaniesList.length === 0
            }
            type="primary"
            className="mt-20 mr-10"
            size="middle"
            style={{ borderRadius: "4px" }}
            onClick={onSaveCompanyGroup}
          >
            {!groupId ? "Add Group" : " Update Group"}
          </Button>
        </div>
      </Card>
    </>
  );
};
